import { Identifier } from 'src/types/utilityTypes';

import {
  RawTag,
  RawTagging,
  RawTaggingsIndexResponse,
  RawTagsIndexResponse,
  Tag,
  Tagging,
} from './_types';

export const normalizeTag = (raw: RawTag): Tag => ({
  id: raw.id,
  name: raw.name,
  tagType: raw.tag_type,
  description: raw.description,
  image: raw.image ?? raw.collection_image_url,
  collectionImageId: raw.collection_image_id,
  originalName: raw.original_name,
});

export const normalizeTags = (data: RawTagsIndexResponse): Tag[] => {
  return extractRawTags(data).map(normalizeTag);
};

export const normalizeTagging = (
  raw: RawTagging,
  defaults?: { taggableId?: Identifier; taggableType?: string }
): Tagging => {
  // V4 tagging serializer nests the tag; derive tagId from tag.id when
  // top-level tag_id is absent (collection taggings index/create).
  const tag = normalizeTag(raw.tag);

  return {
    id: raw.id,
    name: raw.name,
    tagId: raw.tag_id ?? tag.id,
    taggableId: raw.taggable_id ?? defaults?.taggableId ?? '',
    taggableType: raw.taggable_type ?? defaults?.taggableType ?? '',
    sortOrder: raw.sort_order,
    tag,
  };
};

export const extractRawTags = (data: RawTagsIndexResponse): RawTag[] => {
  if (Array.isArray(data)) {
    return data;
  }

  const nested = data.tag ?? data.tags;
  return Array.isArray(nested) ? nested : [];
};

export const extractRawTaggings = (
  data: RawTagging[] | RawTaggingsIndexResponse
): RawTagging[] => {
  if (Array.isArray(data)) {
    return data;
  }

  const nested = data.tag ?? data.taggings;
  return Array.isArray(nested) ? nested : [];
};
